import { createSlice } from "@reduxjs/toolkit";
import { fetchPayoutsThunk, requestPayoutThunk, updatePayoutThunk } from "./payoutsThunk";

const initialState = {
    items: [],
    total: 0,
    totalPages: 0,
    loading: false,
    hasMore: true,
    error: null,
    page: 1
};

const payoutsSlice = createSlice({
    name: "payouts",
    initialState,
    reducers: {
        setPage: (state, action) => {
            state.page = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            // Fetch Payouts
            .addCase(fetchPayoutsThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPayoutsThunk.fulfilled, (state, action) => {
                state.loading = false;
                const data = action.payload;
                const orders = data.content;
                state.items = orders;
                state.total = data.totalElements;
                state.totalPages = data.totalPages;
                state.hasMore = !data.last;
            })
            .addCase(fetchPayoutsThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // create payout
            .addCase(requestPayoutThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(requestPayoutThunk.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(requestPayoutThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // update payout
            .addCase(updatePayoutThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updatePayoutThunk.fulfilled, (state, action) => {
                state.loading = false;
                const updatedPayout = action.payload;
                const index = state.items.findIndex(
                    (payout) => Number(payout.id) === Number(updatedPayout.id)
                );
                if (index !== -1) {
                    state.items[index] = {
                        ...state.items[index],
                        paidAt: updatedPayout.paidAt,
                        status: updatedPayout.status,
                        note: updatedPayout.note,
                        receipts: updatedPayout.receipts
                    };
                }
            })
            .addCase(updatePayoutThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { setPage } = payoutsSlice.actions;
export default payoutsSlice.reducer;
